<template>
  <div>
    <ShowcasePrices />
  </div>
</template>

<script>
import Vue from "vue";
import ShowcasePrices from "./ShowcasePrices";

export default Vue.extend({
  name: "Products",
  components: {
    ShowcasePrices,
  },
});
</script>
